import React from 'react';
import classnames from 'classnames';

import { isElementOfType } from '../../utilities/components';

import WpButton from '../button/WpButton';
import { WpTabs } from '../tabs';
import WpIcon from '../icon/WpIcon';

import './WpModalHeader.scss';

export interface Props {
  children?: React.ReactNode;
  qaTest?: string;
  onToggle?(): void;
}

const classNamePrefix = 'WpModalHeader';

const WpModalHeader: React.FC<Props> = ({ children, onToggle, qaTest }: Props) => {
  const childrenLength = React.Children.count(children);
  const isLastElementTabs = children && childrenLength > 1 && isElementOfType(children[childrenLength - 1], WpTabs);

  const classes = classnames(classNamePrefix, isLastElementTabs ? `${classNamePrefix}--has-tabs` : false);

  return (
    <div className={classes}>
      <div>
        {React.Children.map(children, (child: React.ReactElement<any>) => {
          if (child && isElementOfType(child, [WpTabs])) {
            return <div className={`${classNamePrefix}__tabs`}>{React.cloneElement(child)}</div>;
          }
          return <div className={`${classNamePrefix}__title`}>{child}</div>;
        })}
      </div>
      {onToggle && (
        <div className={`${classNamePrefix}__btn-close`}>
          <WpButton onClick={onToggle} qaTest={qaTest && `${qaTest}__btn-close`} size="sm" variant="tertiary">
            <WpIcon name="times" />
          </WpButton>
        </div>
      )}
    </div>
  );
};

export default WpModalHeader;
